import { Link } from "@mui/material";
import Typography from "component/commonComponents/Typography/Typography";
import Box from "component/layoutComponents/Box/Box";
import styled from "styled-components";
import { Theme } from "./types";

export const TextGray = styled(Typography)<{ theme: Theme }>(({ theme }) => ({
  color: theme.uptimeColors.textColors.secondary,
}));

export const TextBlack = styled(Typography)<{ theme: Theme }>(({ theme }) => ({
  color: theme.uptimeColors.textColors.primary,
}));

export const TextLineThrough = styled(TextGray)(() => ({
  textDecorationLine: "line-through",
}));

export const Image = styled.img<{isDisabled?: boolean}>(({isDisabled = false}) => ({
  height: "100%",
  width: "110px",
  opacity: isDisabled ? 0.5 : 1
}));

export const CardContainer = styled(Box)<{ theme: Theme }>(({ theme }) => ({
  backgroundColor: theme.uptimeColors.mainTheme.background,
  borderRadius: "16px",
  padding: "24px 32px",
  height: "100%",
}));

export const StyledLink = styled(Link)<{ theme: Theme }>(({ theme }) => ({
  color: `${theme.uptimeColors.mainTheme.primary} !important`,
  cursor: "pointer",
}));